<template>
  <router-view class="page"></router-view>
</template>

<script>
export default {}
</script>
